module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-38-ef830ae1d619d9d9f82b796bae96c809.svg";